/**
 * Checks if the dataset contains an emissions table
 * @param {Array} dataSet - Array of data table objects
 * @returns {Boolean} True if the dataset contains an emissions table, false otherwise
 */
export const hasEmissionsTable = (dataSet) => {
  return dataSet.some(
    (data) =>
      data?.contentType === 'dt_ccd_electricity_greenhouse_gas_emissions' ||
      data?.contentType === 'dt_ccd_greenhouse_gas_emissions' ||
      data?.contentType === 'dt_ccd_electricity_greenhouse_gas_emissions___exempt',
  );
};

/**
 * Checks if the table is an emissions table
 * @param {Object} dataTable - Data table object
 * @returns {Boolean} True if the table is an emissions table, false otherwise
 */
export const isEmissionsTable = (dataTable) => {
  return (
    dataTable?.dataSetId === 'dt_ccd_electricity_greenhouse_gas_emissions' ||
    dataTable?.dataSetId === 'dt_ccd_greenhouse_gas_emissions' ||
    dataTable?.dataSetId === 'dt_ccd_electricity_greenhouse_gas_emissions___exempt' ||
    dataTable?.dataSetId === 'dt_ccd_electricity_greenhouse_gas_emissions,dt_ccd_electricity_greenhouse_gas_emissions___exempt'
  );
};
